import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    avatars: [
      require("@/assets/avatars/007-man.png"),
      require("@/assets/avatars/001-avatar.png"),
      require("@/assets/avatars/010-smileys.png"),
      require("@/assets/avatars/009-avatar-7.png"),
      require("@/assets/avatars/008-avatar-6.png"),
      require("@/assets/avatars/006-avatar-5.png"),
      require("@/assets/avatars/005-avatar-4.png"),
      require("@/assets/avatars/004-avatar-3.png"),
      require("@/assets/avatars/003-avatar-2.png"),
      require("@/assets/avatars/002-avatar-1.png")
    ],
    chatMessages: [],
    kgames: {
      profilePicture: "",
      username: "",
      authorizations: []
    }
  },
  mutations: {
    addMessage(state, object) {
      state.chatMessages.push(object);
    },
    kgamesConnect(state, object) {
      for (const key in state.kgames) {
        state.kgames[key] = object[key];
      }
    }
  },
  actions: {},
  getters: {
    isPremium(state) {
      return state.kgames.authorizations.includes("un_premium");
    }
  },
  modules: {}
});
